<template>
  <div class="uk-card uk-card-status">
    <div
      v-if="isLoading"
      class="uk-margin-auto uk-text-center"
    >
      <div uk-spinner />
    </div>
    <div
      v-else
      @click.prevent="$router.push({ name: `${routeName}`, query: queryParams })"
    >
      <h5
        class="title"
        :class="cssTitle(typeTitle)"
      >
        {{ formatCurrencyDigit(data) || '0' }} {{ subtitle }}
      </h5>
      <div>
        <span
          class="status-label"
          :class="cssStatus(typeStatus)"
        >
          {{ status || '' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { currencyDigit } from '@/utils/formater'

export default {
  props:{
    isLoading: {
      required: true,
      type: Boolean
    },
    typeTitle: {
      required: true,
      type: String
    },
    typeStatus: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: String
    },
    subtitle: {
      required: true,
      type: String
    },
    status: {
      required: true,
      type: String
    },
    routeName: {
      required: true,
      type: String
    },
    queryParams: {
      required: true,
      type: Object
    }
  },
  methods: {
    formatCurrencyDigit(data) {
      return currencyDigit(data)
    },
    cssTitle(typeTitle) {
      switch (typeTitle) {
      case 'blue':
        return 'title-blue'
      default:
        return 'title-black'
      }
    },
    cssStatus(typeStatus){
      switch (typeStatus) {
      case 'green':
        return 'label-green'
      case 'red':
        return 'label-red'
      case 'orange':
        return 'label-orange'
      case 'blue-cold':
        return 'label-blue-cold'
      default:
        return 'label-grey'
      }
    }
  }
}
</script>

<style scoped>
  h5.title {
    font-family: 'PoppinsMedium';
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 7px;
  }
  .uk-card-status {
    padding: 20px 24px;
    background-color: #fff;
    border-radius: 16px;
    cursor: pointer;
  }
  .status-label {
    font-family: 'PoppinsMedium';
    font-size: 15px;
    font-weight: 600;
  }
  .title-blue {
    color: #004FA4;
  }
  .title-black {
    color: #181D25;
  }
  .label-green {
    color: #31B057;
  }
  .label-red {
    color: #EB1C24;
  }
  .label-orange {
    color: #F0AD4E;
  }
  .label-blue-cold {
    color: #17A2B8;
  }
  .label-grey {
    color: #8592AD !important;
  }
</style>
